<template>
  <div class="mb-3" v-if="options && options.length!=0">

  <div v-if="facetname=='Action_Status'">
    <b-card border-variant="light" bg-variant="light" text-variant="dark"><b>{{$t('scifund.labels.'+facetname)}}</b></b-card>
    <multiselect
      v-model="selected"
      :options="options"
      :multiple="true"
      :hide-selected="false"
      :taggable="false"
      :showPointer="false"
      :showLabels="false"
      :preserve-search="true"
      :internalSearch="true"
      label="name"
      track-by="name"
      :preselect-first="false"
      @select="facetChangedMultiselect"
      @remove="facetChangedMultiselect"
      :placeholder="$t('scifund.labels.'+facetname)"
      class="always-open"
      >
      </multiselect>
      <FacetHierarchy class="mt-3" v-bind:facetname="'Programme_Divisions_Alt'" ></FacetHierarchy>

  </div>
  <div v-else>
    <label class="facetlabel" v-if="this.hasActivefilter">{{$t('scifund.labels.'+facetname)}}</label>
    <span v-if="facetname=='Eligible_Countries'" >
      &nbsp;<b-icon icon="exclamation-circle-fill" variant="secondary" v-b-popover.hover.top="'Information about the eligibility of associated and third countries is determined by rule-based techniques on calls from 2021 onwards and may be inaccurate. Please review call text for certainty.'"></b-icon>
    </span>
    <multiselect
      v-model="selected"
      :options="options"
      :multiple="true"
      :close-on-select="true"
      :clear-on-select="true"
      :hide-selected="false"
      :searchable="true"
      :preserve-search="true"
      :internalSearch="true"
      :taggable="false"
      :showPointer="true"
      :showLabels="false"
      label="name"
      track-by="name"
      :preselect-first="false"
      @select="facetChangedMultiselect"
      @remove="facetChangedMultiselect"
      :placeholder="$t('scifund.labels.'+facetname)"
      class="not-open"
      >
      <!--
        <template slot="selection" slot-scope="{ values, search, isOpen }">
          <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span>
        </template>

        <template slot="tag">{{ '' }}</template>-->
    </multiselect>

  </div>

</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import FacetHierarchy from '@/components/FacetHierarchy'

export default {
  name: 'facetfield',
  components: { Multiselect, FacetHierarchy, },
  data () {
    return {
      selected: '',
      options: []
    }
  },
  props: [ 'facet', 'facetname' ],
  watch: {
    facet: function (newFacet) { // watch it
      this.options = [];
      this.selected = [];
      for (var item in newFacet) {
        this.options.push({
          name: newFacet[item].value + ' (' + newFacet[item].count + ')',
          action: newFacet[item].sem_action.sem_url_action
        });
        if (newFacet[item].active) {
          this.selected.push({
            name: newFacet[item].value + ' (' + newFacet[item].count + ')',
            action: newFacet[item].sem_action.sem_url_action
          });
        }
      }
    }
  },
  created: function () {
    this.options = [];
    this.selected = [];
    for (var item in this.facet) {
      this.options.push({
        name: this.facet[item].value + ' (' + this.facet[item].count + ')',
        action: this.facet[item].sem_action.sem_url_action
      });
      if (this.facet[item].active) {
        this.selected.push({
          name: this.facet[item].value + ' (' + this.facet[item].count + ')',
          action: this.facet[item].sem_action.sem_url_action
        });
      }
    }
  },
  methods: {
    facetChanged: function (e) {
      this.$router.push( e['sem_action']['sem_url_action'] );
    },
    facetChangedMultiselect: function (e) {
      this.$router.push(e['action']);
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    facets () {
      if (this.$store.state.response &&
          this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_fields) {
        return this.$store.state.response.facet_counts.facet_fields
      }
      return null;
    },
    hasActivefilter () {
      if (this.$store.state.response &&
          this.$store.state.response.active_filters &&
          this.$store.state.response.active_filters.filters ) {
          var activefilters = this.$store.state.response.active_filters.filters;

          for( var i in activefilters ) {
            if( this.facetname == activefilters[i].componentName )
              return true;
          }
      }
      return false;
    },
  }
}
</script>

<style scoped>
.card-body {
  padding: 8px 12px;
}
.facetlabel {
  font-size: 14px;
  color: #888;
  font-weight: 700;
}
</style>
